<template>
    <div>
        <div class="md-layout board-layout-margin">
            <label-az-group style="margin-bottom: 2rem;"/>
            <md-tabs class="md-primary tabs-boards" md-alignment="centered" >
                <md-tab id="tab-mec" md-label="Modelo de Engorde a Corral">
                    <p style="text-align: center;">
                        <iframe title="Tablero Cierre Diario" src="https://app.powerbi.com/view?r=eyJrIjoiOTcwZDVkMzgtMGJlNi00NTBiLTkyMTMtYzY2MmE2NDViOWFjIiwidCI6ImY4MzNmNjI4LTA4MGEtNDJkOS1hOTVmLWU5ZTFjM2Y0MWNiZCJ9" width="1000" height="622" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
                    </p>
                </md-tab>
                <md-tab id="tab-sr" md-label="Simulador de Recría">
                    <p style="text-align: center;">
                        <iframe title="Tablero Cierre Diario" src="https://app.powerbi.com/view?r=eyJrIjoiZWZhZjU0ODEtMTMyYy00ZTZiLWE0OGUtYjNmZTAzYmM1NDYzIiwidCI6ImY4MzNmNjI4LTA4MGEtNDJkOS1hOTVmLWU5ZTFjM2Y0MWNiZCJ9&amp;pageName=de96ef21d3dbe28085f2" width="1000" height="622" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
                    </p>
                </md-tab>
            </md-tabs>
            <p style="text-align: center; width: 100%; font-size: 1rem; font-style: italic;">Recomendamos visualizar los tableros en versión de computadora de escritorio.</p>
        </div>
    </div>
</template>
<script>
    import LabelAzGroup from '@/components/LabelAzGroup.vue'
export default {
    name: 'TabsOrdering',
    components: { LabelAzGroup }
}
</script>

<style>
.tabs-boards {
    background-color: #fff !important;
    margin-top: 2rem;
}
.tabs-boards .md-tabs {
    box-shadow: none;
    border-bottom: 1px solid #bbb !important;
}
.tabs-boards .md-button {
    font-weight: bold;
    font-size: 14px;
    color: #333 !important;
    text-transform: inherit;
}
.tabs-boards .md-tabs-navigation {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    box-shadow: none !important;
    background-color: #ddd !important;
}
.tabs-boards .md-button.md-active {
    border-bottom: solid 2px #0061ad !important;
}
.tabs-boards .md-button:hover {
    border-bottom: solid 2px #0061ad !important;
}
.tabs-boards .md-tab-content {
    padding: 1rem;
}
.tabs-boards iframe {
    border: none;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 8px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    min-height: 622px;
}
.md-layout.board-layout-margin{
    padding-top: 2rem; display: block; text-align: center; overflow: auto;
}
@media screen and (max-width: 720px) {
    .tabs-boards iframe {
        min-height: 250px;
    }
}
@media screen and (max-width: 600px) {
    .tabs-boards {
        margin-top: 0.5rem;
    }
    .md-layout.board-layout-margin{
        padding-top: 0.5rem; display: block; text-align: left; overflow: auto;
    }
    .md-tabs-navigation {
        padding: 0 !important;
    }
    .md-button-content {
        font-size: 12px !important;
    }
}
</style>